import * as _actions from './actions';
import _reducer from './reducer';
import _KetExam, { KetSkill, KetStudentResult, KET_EXAM_TYPE_MOCK, KET_EXAM_TYPE_REAL } from './model';
import * as _accessors from './accessors';

_KetExam.actions = _actions;
_KetExam.accessors = _accessors;

export const actions = _actions;
export const accessors = _accessors;
export const reducer = _reducer;
export const KetExam = _KetExam;
export { KetSkill, KetStudentResult, KET_EXAM_TYPE_MOCK, KET_EXAM_TYPE_REAL };



// WEBPACK FOOTER //
// ./data/KetExams/index.js